module.exports = __webpack_public_path__ + "static/img/stripe-payment.6574c53.png";